import { useMemo } from 'react'

import { useScreen } from '@/store/screen'

export const useChallenge = () => {
  const { windowSize } = useScreen()

  const fontSizesByScreenSize = useMemo(() => {
    const fontsSizesByScreen = {
      1440: {
        title: 'h3' as const,
        description: 'b2' as const,
      },
      700: {
        title: 'b1' as const,
        description: 'b3' as const,
      },
    }
    return fontsSizesByScreen
  }, [])

  const { width } = windowSize
  const fontSizes = useMemo(() => {
    if (!width) return fontSizesByScreenSize[1440]
    if (width <= 700) return fontSizesByScreenSize[700]
    return fontSizesByScreenSize[1440]
  }, [width, fontSizesByScreenSize])

  return {
    fontSizes,
  }
}
